//#Global Imports
import React from "react";
import clsx from "clsx";
import moment from "moment";
//#end Global Imports

//#Local Imports
import ErrorField from "../../../../components/ui/ErrorField";
import TextField from "../../../../components/ui/TextField";
import Button from "../../../../components/ui/Button";
import { PassportIcon, ReloadIcon, UploadIcon } from "../../../../assets/Icons";
import IUserDocuments from "../../userDocuments";
import { DatePicker } from "../../../../components/ui/DatePicker";
//#end Local Imports

const DrivingLicenseSection: React.FC<IUserDocuments.IDrivingLicenseSectionProps> = ({
  drivingLicenseDetails,
  handleDeleteDoc,
  handleChangeUpload,
  setDrivingLicenseDetails,
  handleEverifyDL,
  handleDlDobChangeHandler,
  docDob,
  buttonLoader,
}) => {
  const convertedDate = moment(docDob, "DD/MM/YYYY").toDate();
  const maxDate = moment(new Date()).format("YYYY-MM-DD").toString();

  return (
    <div className="col-span-4 lg:pl-10 lg:pt-7">
      <div>
        <div className="mb-5 text-base font-medium text-black font-lato">
          Upload Driving License<span className="text-error">*</span>
        </div>
        <div className="relative">
          <div className="flex items-center space-x-8">
            <Button
              bgColor="bg-transparent"
              fontStyle={{
                fontFamily: "",
                fontSize: "text-sm",
                fontWeight: "font-normal ",
                fontColor: "text-black-200",
              }}
              borderStyle={{
                borderWidth: "border",
                borderColor: `${
                  drivingLicenseDetails.isDlDocVerified || drivingLicenseDetails.isDLFrontUploaded
                    ? "border-success-150"
                    : "border-grey-150"
                }`,
                borderRadius: "rounded",
              }}
              className="w-full mb-5 h-[68px] lg:!w-[48%]"
            >
              <div className="flex items-center justify-between w-full px-4 lg:px-6">
                <div className="flex items-center space-x-2 lg:space-x-6">
                  <PassportIcon
                    width="23px"
                    height="29px"
                    fillColor={
                      drivingLicenseDetails.isDlDocVerified ||
                      drivingLicenseDetails.isDLFrontUploaded
                        ? "fill-success-150"
                        : "fill-primary"
                    }
                  />
                  <div>Upload driving license front</div>
                </div>
                <div className="flex items-center space-x-2">
                  {!drivingLicenseDetails.isDlDocVerified &&
                    !drivingLicenseDetails?.isDLBackUploaded &&
                    (drivingLicenseDetails.isDLFrontUploaded ? (
                      <div
                        onClick={
                          drivingLicenseDetails.isDLFrontUploaded &&
                          !drivingLicenseDetails.isDlDocVerified
                            ? handleDeleteDoc
                            : () => ""
                        }
                        className="z-50 cursor-pointer"
                      >
                        <ReloadIcon fillColor="fill-secondary-600" width="24" height="24" />
                      </div>
                    ) : (
                      <UploadIcon fillColor="fill-secondary-600" />
                    ))}
                </div>
              </div>
            </Button>
          </div>
          {drivingLicenseDetails.uploadedDocError !== "" && (
            <ErrorField errorMessage={drivingLicenseDetails.uploadedDocError} />
          )}
          <form encType="multipart/form-data" action="">
            <TextField
              accept="image/*,application/pdf"
              name="drivingLicenseFront"
              type="file"
              disabled={drivingLicenseDetails.isDLFrontUploaded}
              rootClassName="absolute top-0 opacity-0 !w-full lg:!w-[48%]"
              onChange={(e) => handleChangeUpload(e, "DRIVING_LICENCE")}
              onClick={(event) => {
                event.currentTarget.value = "";
              }}
            />
          </form>
        </div>
        <div className="relative">
          <div className="flex items-center space-x-8">
            <Button
              bgColor="bg-transparent"
              fontStyle={{
                fontFamily: "",
                fontSize: "text-sm",
                fontWeight: "font-normal ",
                fontColor: "text-black-200",
              }}
              borderStyle={{
                borderWidth: "border",
                borderColor: `${
                  drivingLicenseDetails.isDlDocVerified || drivingLicenseDetails.isDLBackUploaded
                    ? "border-success-150"
                    : "border-grey-150"
                }`,
                borderRadius: "rounded",
              }}
              className="w-full mb-5 h-[68px] lg:!w-[48%]"
            >
              <div className="flex items-center justify-between w-full px-4 lg:px-6">
                <div className="flex items-center space-x-2 lg:space-x-6">
                  <PassportIcon
                    width="23px"
                    height="29px"
                    fillColor={
                      drivingLicenseDetails.isDlDocVerified ||
                      drivingLicenseDetails.isDLBackUploaded
                        ? "fill-success-150"
                        : "fill-primary"
                    }
                  />
                  <div>Upload driving license back</div>
                </div>
                <div className="flex items-center space-x-2">
                  {!drivingLicenseDetails.isDlDocVerified &&
                    (drivingLicenseDetails.isDLBackUploaded ? (
                      <div
                        onClick={
                          drivingLicenseDetails.isDLBackUploaded &&
                          !drivingLicenseDetails.isDlDocVerified
                            ? handleDeleteDoc
                            : () => ""
                        }
                        className="z-50 cursor-pointer"
                      >
                        <ReloadIcon fillColor="fill-secondary-600" width="24" height="24" />
                      </div>
                    ) : (
                      <UploadIcon fillColor="fill-secondary-600" />
                    ))}
                </div>
              </div>
            </Button>
          </div>
          <form encType="multipart/form-data" action="">
            <TextField
              accept="image/*,application/pdf"
              name="drivingLicenseBack"
              type="file"
              disabled={
                drivingLicenseDetails.isDLBackUploaded || !drivingLicenseDetails.isDLFrontUploaded
              }
              rootClassName="absolute top-0 opacity-0 !w-full lg:!w-[48%]"
              onChange={(e) => {
                setDrivingLicenseDetails((preValue) => {
                  return {
                    ...preValue,
                    dlBackFile: URL.createObjectURL(e.target.files[0]),
                    isDLBackUploaded: true,
                    dlBackImageFileName: e.target.files[0].name,
                  };
                });
              }}
              onClick={(event) => {
                event.currentTarget.value = "";
              }}
            />
          </form>
        </div>
        <div className="flex flex-col items-start w-full space-x-8 lg:items-start lg:flex-row">
          <div className="w-full">
            <div className="mb-5 text-base font-medium text-black font-lato">
              Driving license no.<span className="text-error">*</span>
            </div>
              <TextField
              name="drivingLicenseNumber"
              type="text"
              placeholderStyle="!text-primary-850"
              inputClasses={clsx(
                drivingLicenseDetails.isDlDocVerified ? "border-success-150" : "border-grey-150",
                "border !pt-1 lg:!w-full",
              )}
              value={
                drivingLicenseDetails?.isDLFrontUploaded ? drivingLicenseDetails?.dlNumber : ""
              }
              onChange={(event) => {
                setDrivingLicenseDetails((preValue: any) => {
                  return {
                    ...preValue,
                    dlNumber: event.target.value,
                  };
                });
              }}
              error={drivingLicenseDetails.errorMessageDLVerified !== ""}
              disabled={!drivingLicenseDetails?.isDLFrontUploaded}
              fullWidth
              pattern="[a-zA-Z0-9 ]{1,}"
            />
            <div
              className={clsx(
                drivingLicenseDetails.errorMessageDLVerified !== ""
                  ? "text-error"
                  : drivingLicenseDetails.messageDLVerified !== ""
                  ? "text-success"
                  : "",
                " font-ssp font-medium text-sm mt-7",
              )}
            >
              {drivingLicenseDetails.errorMessageDLVerified === ""
                ? drivingLicenseDetails.messageDLVerified
                : drivingLicenseDetails.errorMessageDLVerified}
            </div>
          </div>
          <div className="w-full">
            <div className="mb-5 text-base font-medium text-black font-lato">DOB as per DL</div>
            <DatePicker
              selectedDate={
                docDob === "" ? new Date().toString() : moment(convertedDate).format("YYYY-MM-DD")
              }
              dateChangeHandler={handleDlDobChangeHandler}
              datepickerClassname="bg-transparent !p-4 !rounded border !border-grey-150 lg:w-[300px]"
              disabled={
                !drivingLicenseDetails?.isDLFrontUploaded || drivingLicenseDetails?.isDlDocVerified
              }
              maxDate={maxDate}
            />
          </div>
        </div>

        {!drivingLicenseDetails.isDlDocVerified && (
          <Button
            bgColor={
              drivingLicenseDetails.isDLFrontUploaded && drivingLicenseDetails.isDLBackUploaded
                ? "bg-primary"
                : "bg-grey-350"
            }
            fontStyle={{
              fontFamily: "",
              fontSize: "text-base",
              fontWeight: "font-bold",
              fontColor: "text-white",
            }}
            className={"py-5 w-full mt-9 lg:!w-[48%]"}
            disabled={
              !drivingLicenseDetails.isDLFrontUploaded || !drivingLicenseDetails.isDLBackUploaded
            }
            isLoading={buttonLoader.everifyDLLoader}
            onClickHandler={handleEverifyDL}
          >
            Verify
          </Button>
        )}
      </div>
    </div>
  );
};

export default DrivingLicenseSection;
